// Rutas de la vista Semáforo. router.tsx las suma con una sola línea.
import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Tablero } from "./Tablero";
import { NuevoTicket } from "./NuevoTicket";
import { DetalleTicket } from "./DetalleTicket";
import { MiArea } from "./MiArea";
import { Avisos } from "./Avisos";

export function rutasSemaforo(raiz: AnyRoute) {
  return [
    createRoute({ getParentRoute: () => raiz, path: "/tablero", component: Tablero }),
    createRoute({ getParentRoute: () => raiz, path: "/tickets/nuevo", component: NuevoTicket }),
    createRoute({ getParentRoute: () => raiz, path: "/tickets/$id", component: DetalleTicket }),
    createRoute({
      getParentRoute: () => raiz,
      path: "/area",
      component: MiArea,
      validateSearch: (s: Record<string, unknown>) => ({ area: typeof s.area === "string" ? s.area : undefined }),
    }),
    createRoute({ getParentRoute: () => raiz, path: "/avisos", component: Avisos }),
  ];
}
